var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.41667 16.667H4.16667C3.24619 16.667 2.5 15.9208 2.5 15.0003V3.33366C2.5 2.41318 3.24619 1.66699 4.16667 1.66699H15.8333C16.7538 1.66699 17.5 2.41318 17.5 3.33366V15.0003C17.5 15.9208 16.7538 16.667 15.8333 16.667H14.5833M10 15.8337C11.3807 15.8337 12.5 14.7144 12.5 13.3337C12.5 11.9529 11.3807 10.8337 10 10.8337C8.61929 10.8337 7.5 11.9529 7.5 13.3337C7.5 14.7144 8.61929 15.8337 10 15.8337ZM10 15.8337L10.0179 15.8335L7.35723 18.4941L5.0002 16.1371L7.51638 13.6209M10 15.8337L12.6607 18.4941L15.0177 16.1371L12.5015 13.6209M7.5 5.00033H12.5M5.83333 7.91699H14.1667",
    stroke: "#505050",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.36766ce31c72619f1ae73fad635dc52c.svg";
export { ForwardRef as ReactComponent };